import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { FirebaseService, City, Venue, AuthService } from "src/app/core";
import { ProductType } from "src/app/core/product/enums";
@Component({
  selector: "ll-filter-orders",
  templateUrl: "./filter-orders.component.html",
  styleUrls: ["./filter-orders.component.scss"]
})
export class FilterOrdersComponent implements OnInit {
  objectKeys = Object.keys;
  form: FormGroup;

  constructor(public fb: FirebaseService, private auth: AuthService) {
    this.init();
  }

  ngOnInit() {}

  get allCities(): Boolean {
    return this.fb.orders.filter.currentCity == null;
  }

  get isAdmin() {
    return this.auth.admin;
  }
  get timeframes() {
    return this.fb.orders.filter.timeframes;
  }
  get productTypes() {
    return this.fb.orders.filter.productTypes;
  }
  get currentCity() {
    return this.fb.orders.filter.currentCity;
  }
  set currentCity(city: City) {
    this.fb.orders.filter.currentCity = city;
  }
  get currentVenue() {
    return this.fb.orders.filter.currentVenue;
  }
  set currentVenue(venue: Venue) {
    this.fb.orders.filter.currentVenue = venue;
  }
  get currentTimeframe() {
    return this.fb.orders.filter.currentTimeframe;
  }
  get currentType() {
    return this.fb.orders.filter.currentType;
  }
  set currentType(type) {
    this.fb.orders.filter.currentType = type;
  }
  get showRedeemed() {
    return this.fb.orders.filter.showRedeemed;
  }
  set showRedeemed(b) {
    this.fb.orders.filter.showRedeemed = b;
  }

  get showOutstanding() {
    return this.fb.orders.filter.showOutstanding;
  }

  set showOutstanding(b) {
    this.fb.orders.filter.showOutstanding = b;
  }
  get types() {
    return this.objectKeys(this.productTypes);
  }
  get isLoading(): boolean {
    return (
      (this.fb.city == null && this.auth.admin) ||
      this.fb.orders == null ||
      this.fb.orders.filter == null
    );
  }
  init() {
    this.form = new FormGroup({
      city:
        this.currentCity == null
          ? new FormControl("All")
          : new FormControl(
              this.currentCity.city_name + ", " + this.currentCity.state
            ),
      venue:
        this.currentVenue == null
          ? new FormControl("All")
          : new FormControl(this.currentVenue.name),
      timeframe: new FormControl(this.currentTimeframe),
      productType:
        this.currentType == null
          ? new FormControl("All")
          : new FormControl(ProductType[this.currentType])
    });
  }

  filter() {
    this.fb.orders.filter.filter();
  }

  /** BEGIN CITIES FILTER */
  get cities(): City[] {
    return this.fb.city.cities.sort((one, two) =>
      one.city_name > two.city_name ? 1 : -1
    );
  }

  changeCity(city: City) {
    this.form.controls.city.setValue(city.city_name + ", " + city.state);
    this.fb.orders.filter.currentCity = city;
    this.checkVenueForReset();
    this.filter();
  }

  resetCity() {
    this.form.controls.city.setValue("All");
    this.currentCity = null;
    this.checkVenueForReset();
    this.filter();
  }

  /** BEGIN VENUES FILTER */
  get venues(): Venue[] {
    if (this.currentCity != null)
      return this.fb.venues.filter(
        venue => venue.city.id == this.currentCity.id
      );
    return this.fb.venues.sort((a, b) => (a.name < b.name ? -1 : 1));
  }

  changeVenue(venue: Venue) {
    this.form.controls.venue.setValue(venue.name);
    this.currentVenue = venue;
    this.filter();
  }

  resetVenue() {
    this.form.controls.venue.setValue("All");
    this.currentVenue = null;
    this.filter();
  }

  checkVenueForReset() {
    if (
      !this.venues
        .map(venue => venue.name)
        .includes(this.form.controls.venue.value) ||
      this.currentCity == null
    ) {
      this.form.controls.venue.setValue("All");
      this.currentVenue = null;
    }
  }
  /** END VENUES FILTER */

  /** BEGIN PRODUCT TYPE FILTER */
  changeType(type: string) {
    this.form.controls.productType.setValue(type);
    this.currentType = this.productTypes[type];
    this.filter();
  }

  resetType() {
    this.form.controls.productType.setValue("All");
    this.currentType = null;
    this.filter();
  }
  /** END PRODUCT TYPE FILTER */

  /** BEGIN REDEMPTION FILTER */
  changeRedeemed(val: boolean) {
    this.showRedeemed = val;
    this.filter();
  }

  changeOutstanding(val: boolean) {
    this.showOutstanding = val;
    this.filter();
  }
  /** END REDEMPTION FILTER */

  /** BEGIN TIMEFRAME FILTER */
  changeTimeframe(tf: string) {
    this.form.controls.timeframe.setValue(tf);
    this.fb.orders.changeTimeframe(tf, this.timeframes[tf]);
  }
  /** END TIMEFRAME FILTER */
}
